import React from "react";
import styled from "styled-components";
import { InnerLayout } from "../styles/Layouts";
import Title from "../Components/Title";
import SmallTitle from "../Components/SmallTitle";
import BusinessCenterIcon from "@material-ui/icons/BusinessCenter";
import SchoolIcon from "@material-ui/icons/School";
import ResumeItem from "../Components/ResumeItem";

function Resume() {
  const briefcase = <BusinessCenterIcon />;
  const school = <SchoolIcon />;
  return (
    <ResumeStyled>
      <Title title={"Resume"} span={"resume"} />
      <InnerLayout>
        <div className="small-title">
          <SmallTitle icon={briefcase} title={"National Service"} />
        </div>
        <div className="resume-content">
          <ResumeItem
            year={"July, 2013 - September,2014"}
            title={"NHIA, Marketing /PR Department"}
            text={"Successfully completed my National Service ."}
          />
        </div>

        <div className="small-title u-small-title-margin">
          <SmallTitle icon={school} title={"Educational Qualifications"} />
        </div>
        <div className="resume-content ">
          <ResumeItem
            year={"Jan, 2022 - Present"}
            title={"Full Stack Developement"}
            subTitle={"Open Labs (NIIT), Accra-Ghana"}
            text={"Learning Full Stack Developement & Communication skills. "}
          />
          <ResumeItem
            year={"2010 - 2013"}
            title={"HND Marketing"}
            subTitle={"TATU, Northern Region"}
            text={"Completed a three-year Diploma in Marketing"}
          />
          <ResumeItem
            year={"2006 - 2010"}
            title={"High School Graduation"}
            subTitle={"Ada Secondary School, Greater Accra- Ada"}
            // text={"Completed a three-year Diploma in Marketing"}
          />
        </div>
      </InnerLayout>
    </ResumeStyled>
  );
}

const ResumeStyled = styled.section`
  .small-title {
    padding-bottom: 3rem;
  }
  .u-small-title-margin {
    margin-top: 4rem;
  }
  
  .resume-content {

    border-left: 2px solid var(--border-color);
  }
`;
export default Resume;
